export const DownloadArrowDirectionEnum = {
  UP: 1,
  RIGHT: 2,
  DOWN: 3,
  LEFT: 4,
};

export const SupportedBrowserEnum = {
  CHROME: 1,
  FIREFOX: 2,
  MSIE: 3,
  MSEDGE: 4,
};



// WEBPACK FOOTER //
// ./src-react/download-overlay/DownloadOverlayConstants.jsx